<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import useAsyncDialog from '@/components/dialogs/useAsyncDialog'

const { t } = useI18n()
const { openAsyncDialog, asyncDialogResolve, asyncDialogIsOpen } = useAsyncDialog<string>()

const currentEbomName = ref('')
const newEbomName = ref('')
const currentBopUploadId = ref('')
const newBopUploadId = ref('')

const open = async (args: {
  currentEbomName: string
  newEbomName: string
  currentBopUploadId: string
  newBopUploadId: string
}): Promise<string | undefined> => {
  currentEbomName.value = args.currentEbomName
  newEbomName.value = args.newEbomName
  currentBopUploadId.value = args.currentBopUploadId
  newBopUploadId.value = args.newBopUploadId
  return await openAsyncDialog()
}

defineExpose({ open })
</script>

<template>
  <v-dialog v-if="asyncDialogResolve" v-model="asyncDialogIsOpen" max-width="560" v-bind="$attrs">
    <v-card>
      <v-card-title>
        {{ t('component.cross3dModelWarning.title') }}
        <v-btn
          density="compact"
          icon="close"
          class="float-right"
          variant="flat"
          @click="asyncDialogResolve()"
        />
      </v-card-title>
      <v-card-text>
        <p>
          {{
            t('component.cross3dModelWarning.body', {
              currentEbomName,
              newEbomName,
            })
          }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="asyncDialogResolve()">
          {{ t('button.cancel') }}
        </v-btn>
        <v-btn @click="asyncDialogResolve(currentBopUploadId)">
          {{ t('component.cross3dModelWarning.useCurrent', { currentEbomName }) }}
        </v-btn>
        <v-btn color="primary" variant="elevated" @click="asyncDialogResolve(newBopUploadId)">
          {{ t('component.cross3dModelWarning.useNew', { newEbomName }) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
